import _classCallCheck from "/home/jack/Documents/Billiontags/Projects/React/billiontags-gastby-1/node_modules/@babel/runtime/helpers/esm/classCallCheck";
import _createClass from "/home/jack/Documents/Billiontags/Projects/React/billiontags-gastby-1/node_modules/@babel/runtime/helpers/esm/createClass";
import { RenderTarget } from '../core/RenderTarget.js';
import { Program } from '../core/Program.js';
import { Mesh } from '../core/Mesh.js';
import { Vec2 } from '../math/Vec2.js';
import { Triangle } from './Triangle.js';
export var Flowmap = /*#__PURE__*/function () {
  function Flowmap(gl) {
    var _ref = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {},
        _ref$size = _ref.size,
        size = _ref$size === void 0 ? 128 : _ref$size,
        _ref$falloff = _ref.falloff,
        falloff = _ref$falloff === void 0 ? 0.3 : _ref$falloff,
        _ref$alpha = _ref.alpha,
        alpha = _ref$alpha === void 0 ? 1 : _ref$alpha,
        _ref$dissipation = _ref.dissipation,
        dissipation = _ref$dissipation === void 0 ? 0.98 : _ref$dissipation,
        type = _ref.type;

    _classCallCheck(this, Flowmap);

    var _this = this;

    this.gl = gl; // output uniform containing render target textures

    this.uniform = {
      value: null
    };
    this.mask = {
      read: null,
      write: null,
      // Helper function to ping pong the render targets and update the uniform
      swap: function swap() {
        var temp = _this.mask.read;
        _this.mask.read = _this.mask.write;
        _this.mask.write = temp;
        _this.uniform.value = _this.mask.read.texture;
      }
    };
    {
      createFBOs();
      this.aspect = 1;
      this.mouse = new Vec2();
      this.velocity = new Vec2();
      this.mesh = initProgram();
    }

    function createFBOs() {
      // Requested type not supported, fall back to half float
      if (!type) type = gl.HALF_FLOAT || gl.renderer.extensions['OES_texture_half_float'].HALF_FLOAT_OES;

      var minFilter = function () {
        if (gl.renderer.isWebgl2) return gl.LINEAR;
        if (gl.renderer.extensions["OES_texture_".concat(type === gl.FLOAT ? '' : 'half_', "float_linear")]) return gl.LINEAR;
        return gl.NEAREST;
      }();

      var options = {
        width: size,
        height: size,
        type: type,
        format: gl.RGBA,
        internalFormat: gl.renderer.isWebgl2 ? type === gl.FLOAT ? gl.RGBA32F : gl.RGBA16F : gl.RGBA,
        minFilter: minFilter,
        depth: false
      };
      _this.mask.read = new RenderTarget(gl, options);
      _this.mask.write = new RenderTarget(gl, options);

      _this.mask.swap();
    }

    function initProgram() {
      return new Mesh(gl, {
        // Triangle that includes -1 to 1 range for 'position', and 0 to 1 range for 'uv'.
        geometry: new Triangle(gl),
        program: new Program(gl, {
          vertex: vertex,
          fragment: fragment,
          uniforms: {
            tMap: _this.uniform,
            uFalloff: {
              value: falloff * 0.5
            },
            uAlpha: {
              value: alpha
            },
            uDissipation: {
              value: dissipation
            },
            // User needs to update these
            uAspect: {
              value: 1
            },
            uMouse: {
              value: _this.mouse
            },
            uVelocity: {
              value: _this.velocity
            }
          },
          depthTest: false
        })
      });
    }
  }

  _createClass(Flowmap, [{
    key: "update",
    value: function update() {
      this.mesh.program.uniforms.uAspect.value = this.aspect;
      this.gl.renderer.render({
        scene: this.mesh,
        target: this.mask.write,
        clear: false
      });
      this.mask.swap();
    }
  }]);

  return Flowmap;
}();
var vertex =
/* glsl */
"\n    attribute vec2 uv;\n    attribute vec2 position;\n\n    varying vec2 vUv;\n\n    void main() {\n        vUv = uv;\n        gl_Position = vec4(position, 0, 1);\n    }\n";
var fragment =
/* glsl */
"\n    precision highp float;\n\n    uniform sampler2D tMap;\n\n    uniform float uFalloff;\n    uniform float uAlpha;\n    uniform float uDissipation;\n    \n    uniform float uAspect;\n    uniform vec2 uMouse;\n    uniform vec2 uVelocity;\n\n    varying vec2 vUv;\n\n    void main() {\n        vec4 color = texture2D(tMap, vUv) * uDissipation;\n\n        vec2 cursor = vUv - uMouse;\n        cursor.x *= uAspect;\n\n        vec3 stamp = vec3(uVelocity * vec2(1, -1), 1.0 - pow(1.0 - min(1.0, length(uVelocity)), 3.0));\n        float falloff = smoothstep(uFalloff, 0.0, length(cursor)) * uAlpha;\n\n        color.rgb = mix(color.rgb, stamp, vec3(falloff));\n\n        gl_FragColor = color;\n    }\n";